import { render, staticRenderFns } from "./InstallAppButton.vue?vue&type=template&id=13949032"
import script from "./InstallAppButton.vue?vue&type=script&lang=js"
export * from "./InstallAppButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports